<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="付款单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      show-checkbox
      v-if="trendShow"
      @check-change="checkChange"
      @row-select="rowSelect"
      :queryParamsAppend="{}"
      urlHash="finance/cashier/payment"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <el-table
      v-show="tableData.length !== 0"
      border
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      style="margin-top: 18px"
    >
      <el-table-column
        prop="SettleName"
        label="结算方式"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="AccountName"
        label="付款账户"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="PayAmount"
        label="付款金额"
        min-width="100"
        align="right"
        v-if="canPrice"
      >
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.PayAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="备注"
        min-width="100"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/rp/pay").default,
      trendShow: true,
      list: [],
      tableData: [],
    };
  },

  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/cashier/payment");
    },
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/cashier/payment")) {
      const findIndex = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "PayAmount"
      );
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
    }
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, Fields: fields.join(",") };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.getListExport(params).then((res) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    checkChange(list) {
      this.list = list;
    },
    rowSelect({ DocId }) {
      this.api.info(DocId).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data.Dts;
        }
      });
    },
    review() {
      if (this.list.length === 0) {
        this.$message({ type: "warning", message: "请勾选要审核的记录" });
        return;
      }
      let ids = this.list.map((item) => {
        return item.DocId;
      });

      this.$confirm("是否审核？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.review({ Ids: ids }).then((res) => {
            if (res.Code === 0) {
              this.$message({ type: "success", message: res.Msg });
              this.$emit("reviewed");
            } else {
              this.$message({ type: "warning", message: res.Msg });
            }
          });
        })
        .catch(() => {});
    },
    del() {
      if (this.list.length === 0) {
        this.$message({ type: "warning", message: "请勾选要删除的记录" });
        return;
      }
      let ids = this.list.map((item) => {
        return item.DocId;
      });
      this.$confirm("是否删除数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Ids: ids }).then((res) => {
            if (res.Code === 0) {
              this.$message({ type: "success", message: res.Msg });
              this.$emit("deleted");
            } else {
              this.$message({ type: "warning", message: res.Msg });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
